import React, { Component } from 'react';
import GetConfiguracionCombo from './getConfiguracionCombo';
import GetUploadImage from './getUploadImage';
import Checkbox from '@material-ui/core/Checkbox';
import { confirmAlert } from 'react-confirm-alert';

class getProductos extends Component {
  constructor(props){
    super(props);
    this.state = {
        items : [],
        rubros: [],
        new_producto :  '',
        new_descripcion : '',
        new_precio_1 : 0,
        new_precio_2 : 0,
        new_codigo: '',
        new_orden: 0,
        new_activo:1,
        new_si_iva: 0,
        new_id_rubro: 0,
        sub_modal:'',
        new_sw_no_qr:0,
        new_sw_no_mesa:0,
        new_sw_no_app:0
    }
  }

  getnewItem =()=>{
    const producto = this.state.new_producto
    const descripcion = this.state.new_descripcion
    const precio_1= this.state.new_precio_1
    const precio_2= this.state.new_precio_2
    const codigo= this.state.new_codigo
    const orden= this.state.new_orden
    const activo= this.state.new_activo
    const si_iva= this.state.new_si_iva
    const id_rubro= this.state.new_id_rubro

    const sw_no_qr= this.state.new_sw_no_qr
    const sw_no_mesa= this.state.new_sw_no_mesa
    const sw_no_app= this.state.new_sw_no_app

    if(producto===''){
      alert("Ingrese Nombre Producto")
      return
    }
    if(Number(id_rubro)===0){
      alert("Ingrese Rubro")
      return
    }
    const url= this.props.dir_url + "webapp/getNewItem";
    const token =  this.props.token
    var obj = { accion:'newitem',token, producto,descripcion,precio_1,precio_2,
    codigo,orden,activo,si_iva,id_rubro,sw_no_qr,sw_no_mesa,sw_no_app};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.setState({
        new_producto :  '',
        new_descripcion : '',
        new_precio_1 : 0,
        new_precio_2 : 0,
        new_codigo: '',
        new_orden: 0,
        new_activo:1,
        new_si_iva: 0,
        new_id_rubro: 0,
        new_sw_no_qr:0,
        new_sw_no_mesa: 0,
        new_sw_no_app: 0
      },()=>{
        this.cargar_items()
      })

    })
    .catch(console.log)
    this.props.get_loading(true)
  }


  cargar_items =()=>{
    const url= this.props.dir_url + "webapp/getDataItem";
    const token =  this.props.token
    var obj = { accion:'dataitem', token};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          items : data[0].msg,
          rubros : data[0].msg_2
        })
      }
    })
    .catch(console.log)
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }
  get_opcion_no =()=>{

  }
  getPreferencias =(id_acumulador)=>{
    var items = this.state.items
    let id_producto_modal
    items.forEach(det => {
      if(Number(det.id_acumulador)===Number(id_acumulador)){
          id_producto_modal=det.id_producto
      }
    });
    this.setState({
      sub_modal:'complemento',
      id_producto_modal
    })
  }
  getEliminarItem=(id_acumulador)=>{
    confirmAlert({
      title: 'Eliminar Producto',
      message: '¿Desea Eliminar Producto?',
      buttons: [
        {
          label: 'Sí',
          onClick: () => {
            var items = this.state.items
            items.forEach(det => {
              if(Number(det.id_acumulador)===Number(id_acumulador)){
                  det.eliminado = 1;
              }
            });
            this.setState(
              {items} , ()=>{
                this.getgrabarItem(id_acumulador)
              }
            );

          }
        },
        {
          label: 'No',
          onClick: () => this.get_opcion_no()
        }
      ]
    })
  }

  getgrabarItem=(id_acumulador)=>{
    const items = this.state.items
    let id_item
    let producto
    let descripcion
    let precio_1
    let precio_2
    let codigo
    let si_iva
    let orden
    let eliminado
    let activo
    let id_rubro
    let sw_no_qr
    let sw_no_mesa
    let sw_no_app

    items.forEach(item => {
      if(Number(item.id_acumulador)===Number(id_acumulador)){
        producto = item.producto
        descripcion = item.descripcion
        precio_1 = item.precio_1
        precio_2 = item.precio_2
        codigo = item.codigo
        orden = item.orden
        activo = item.activo
        eliminado = item.eliminado
        id_item = item.id_producto
        si_iva = item.si_iva
        id_rubro = item.id_rubro
        sw_no_qr= item.sw_no_qr
        sw_no_mesa= item.sw_no_mesa
        sw_no_app= item.sw_no_app
      }
    });
    if(Number(id_item)<=0){
      return null
    }

    const url= this.props.dir_url + "webapp/getGrabarItem";
    const token =  this.props.token
    var obj = { accion:'grabaritemdata',token,id_item,producto,descripcion,precio_1,precio_2,codigo,si_iva,orden
    ,eliminado,activo,id_rubro,sw_no_qr,sw_no_mesa,sw_no_app};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.cargar_items()
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  getUUID =(uuid_imagen,id_item,uuid_imagen_2)=>{
    const url= this.props.dir_url + "webapp/getGrabarItem";
    const token =  this.props.token
    var obj = { accion:'grabaritem',token, uuid_imagen,id_item,uuid_imagen_2};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.cargar_items()
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  handleChange_new= (event ,name) => {
    let value = event.target.value
    let checked = event.target.checked

    if(name==="producto"){
      this.setState({
        new_producto : value
      })
    }
    if(name==="descripcion"){
      this.setState({
        new_descripcion : value
      })
    }
    if(name==="precio_1"){
      this.setState({
        new_precio_1 : value
      })
    }
    if(name==="precio_2"){
      this.setState({
        new_precio_2 : value
      })
    }
    if(name==="codigo"){
      this.setState({
        new_codigo : value
      })
    }
    if(name==="orden"){
      this.setState({
        new_orden: value
      })
    }
    if(name==="activo"){
      this.setState({
        new_activo : (checked===true)?"1":"0"
      })
    }
    if(name==="si_iva"){
      this.setState({
        new_si_iva : (checked===true)?"1":"0"
      })
    }
    if(name==="id_rubro"){
      this.setState({
        new_id_rubro : value
      })
    }
    if(name==="sw_no_qr"){
      this.setState({
        new_sw_no_qr : (checked===true)?"1":"0"
      })
    }
    if(name==="sw_no_mesa"){
      this.setState({
        new_sw_no_mesa : (checked===true)?"1":"0"
      })
    }
    if(name==="sw_no_app"){
      this.setState({
        new_sw_no_app : (checked===true)?"1":"0"
      })
    }
  }
  handleChange = (event , index ,name) => {
    var items = this.state.items
    let value = event.target.value
    let checked = event.target.checked

    items.forEach(item => {
      if(Number(item.id_acumulador)===Number(index)){
        if(name==="producto"){
          item.producto = value;
        }
        if(name==="descripcion"){
          item.descripcion = value;
        }
        if(name==="precio_1"){
          item.precio_1 = value;
        }
        if(name==="precio_2"){
          item.precio_2 = value;
        }
        if(name==="codigo"){
          item.codigo = value;
        }
        if(name==="orden"){
          item.orden = value;
        }
        if(name==="activo"){
          item.activo = (checked===true)?"1":"0";
        }
        if(name==="si_iva"){
          item.si_iva = (checked===true)?"1":"0";
        }
        if(name==="id_rubro"){
          item.id_rubro = value;
        }
        if(name==="sw_no_qr"){
          item.sw_no_qr = (checked===true)?"1":"0";
        }
        if(name==="sw_no_mesa"){
          item.sw_no_mesa = (checked===true)?"1":"0";
        }
        if(name==="sw_no_app"){
          item.sw_no_app = (checked===true)?"1":"0";
        }
      }
    });
    this.setState({items});
  }

  llenar_items =()=>{
    //id_producto, producto, descripcion, precio_1, precio_2, codigo, activo, si_iva, orden, uuid_imagen
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_60x60
    //file_250x250
    //const file_xxx =this.props.file_60x60
    const token_image = url_image+file_xxx+separator
    const ext="_60x60.png?alt=media"
    const items = this.state.items
    const rubros = this.state.rubros
    return(
       <React.Fragment>
       <tbody>
        {
          (items)?
          items.map((item , index) => (
            <tr key={index}>
              <td>
              <table className="tb_pedidos">
                <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                  <tr><td>Id_Producto</td><td>{item.id_producto}</td></tr>
                  <tr><td>Producto</td><td>
                  <input  type="text" value={item.producto|| ''} onChange={(e) => {this.handleChange( e , item.id_acumulador ,"producto")}} />
                  </td></tr>
                  <tr><td>Descripción</td><td>
                  <input  type="text" value={item.descripcion|| ''} onChange={(e) => {this.handleChange( e , item.id_acumulador ,"descripcion")}} />
                  </td></tr>
                  <tr><td>Precio 1</td><td>
                  <input  type="text" value={item.precio_1|| ''} onChange={(e) => {this.handleChange( e , item.id_acumulador ,"precio_1")}} />
                  </td></tr>
                  <tr><td>Precio 2</td><td>
                  <input  type="text" value={item.precio_2|| ''} onChange={(e) => {this.handleChange( e , item.id_acumulador ,"precio_2")}} />
                  </td></tr>
                  <tr><td>Código</td><td>
                  <input  type="text" value={item.codigo|| ''} onChange={(e) => {this.handleChange( e , item.id_acumulador ,"codigo")}} />
                  </td></tr>
                  <tr><td>Activo</td><td>
                  <Checkbox
                    checked={(Number(item.activo)===0)?false:true}
                    onChange={(e) => {this.handleChange( e , item.id_acumulador ,"activo")}}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  /></td></tr>
                  <tr><td>IVA</td><td>
                  <Checkbox
                    checked={(Number(item.si_iva)===0)?false:true}
                    onChange={(e) => {this.handleChange( e , item.id_acumulador ,"si_iva")}}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  /></td></tr>
                  <tr><td>NO VISUALIZAR QR</td><td>
                  <Checkbox
                    checked={(Number(item.sw_no_qr)===0)?false:true}
                    onChange={(e) => {this.handleChange( e , item.id_acumulador ,"sw_no_qr")}}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  /></td></tr>
                  <tr><td>NO VISUALIZAR MESA</td><td>
                  <Checkbox
                    checked={(Number(item.sw_no_mesa)===0)?false:true}
                    onChange={(e) => {this.handleChange( e , item.id_acumulador ,"sw_no_mesa")}}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  /></td></tr>
                  <tr><td>NO VISUALIZAR APP</td><td>
                  <Checkbox
                    checked={(Number(item.sw_no_app)===0)?false:true}
                    onChange={(e) => {this.handleChange( e , item.id_acumulador ,"sw_no_app")}}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  /></td></tr>
                  <tr><td>Orden</td><td>
                  <input  type="text" value={item.orden|| ''} onChange={(e) => {this.handleChange( e , item.id_acumulador ,"orden")}} />
                  </td></tr>
                  <tr><td>
                  Rubro</td><td>
                  <select className="select-css_global" value={item.id_rubro} onChange={(e) =>{this.handleChange( e , item.id_acumulador ,"id_rubro")}}>
                  {(rubros.length !== 0) ?
                    rubros.map(rubro => (
                      <option key={rubro.id_rubro} value={rubro.id_rubro} >{rubro.rubro}</option>
                    ))
                    : <React.Fragment></React.Fragment>
                  }
                  </select>
                  </td></tr>
                </tbody>
              </table>
              </td>
              <td>
              <GetUploadImage uuid={item.id_producto} file_xxx_2={this.props.file_250x250} file_xxx={this.props.file_60x60}  firebase={this.props.firebase} getUUID={this.getUUID}
              width={'60px'} height={'60px'} pref={'_60x60'}  token_image={
                (item.uuid_imagen)?
                token_image+item.uuid_imagen+ext:''
              } />
              </td>
              <td>
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getgrabarItem(item.id_acumulador)}>
                  Grabar
                </button>
                <br/>
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getEliminarItem(item.id_acumulador)}>
                  Eliminar
                </button>
                <br/>
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getPreferencias(item.id_acumulador)}>
                  Adicionales
                </button>
              </td>
            </tr>
          )) :''
      }
      </tbody>
      </React.Fragment>
    )
  }

  getSalirComplementos =()=>{
    this.setState({
      sub_modal:'',
      id_producto_modal:0
    })
  }
  render() {
    const sub_modal = this.state.sub_modal
    let sub_pantalla_modal
    if(sub_modal==='complemento'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                          <GetConfiguracionCombo getSalirComplementos={this.getSalirComplementos} id_producto_modal={this.state.id_producto_modal}
                          token={this.props.token} dir_url={this.props.dir_url}
                          get_aceptar_pedido={this.get_salir_vista_pedido}/>
                        </div>
    }

    return(
      <React.Fragment>
      <div className="" style={{"backgroundColor":"white","color":"black"}}>
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_">Productos</div>
        </div>
      </div>
      <div style={{"backgroundColor":"white","height":"100%","color":"black","overflowY": "auto"}}>
        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Campo</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>

          <tr><td>Producto</td><td>
          <input  type="text" value={this.state.new_producto|| ''} onChange={(e) => {this.handleChange_new( e  ,"producto")}} />
          </td></tr>
          <tr><td>Descripción</td><td>
          <input  type="text" value={this.state.new_descripcion|| ''} onChange={(e) => {this.handleChange_new( e  ,"descripcion")}} />
          </td></tr>
          <tr><td>Precio 1</td><td>
          <input  type="text" value={this.state.new_precio_1|| ''} onChange={(e) => {this.handleChange_new( e   ,"precio_1")}} />
          </td></tr>
          <tr><td>Precio 2</td><td>
          <input  type="text" value={this.state.new_precio_2|| ''} onChange={(e) => {this.handleChange_new( e   ,"precio_2")}} />
          </td></tr>
          <tr><td>Código</td><td>
          <input  type="text" value={this.state.new_codigo|| ''} onChange={(e) => {this.handleChange_new( e  ,"codigo")}} />
          </td></tr>
          <tr><td>Activo</td><td>
          <Checkbox
            checked={(Number(this.state.new_activo)===0)?false:true}
            onChange={(e) => {this.handleChange_new( e   ,"activo")}}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          /></td></tr>
          <tr><td>IVA</td><td>
          <Checkbox
            checked={(Number(this.state.new_si_iva)===0)?false:true}
            onChange={(e) => {this.handleChange_new( e  ,"si_iva")}}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          /></td></tr>
          <tr><td>NO VISUALIZAR QR</td><td>
          <Checkbox
            checked={(Number(this.state.new_sw_no_qr)===0)?false:true}
            onChange={(e) => {this.handleChange_new( e ,"sw_no_qr")}}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          /></td></tr>
          <tr><td>NO VISUALIZAR MESA</td><td>
          <Checkbox
            checked={(Number(this.state.new_sw_no_mesa)===0)?false:true}
            onChange={(e) => {this.handleChange_new( e  ,"sw_no_mesa")}}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          /></td></tr>
          <tr><td>NO VISUALIZAR APP</td><td>
          <Checkbox
            checked={(Number(this.state.new_sw_no_app)===0)?false:true}
            onChange={(e) => {this.handleChange_new( e ,"sw_no_app")}}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          /></td></tr>
          <tr><td>Orden</td><td>
          <input  type="text" value={this.state.new_orden|| ''} onChange={(e) => {this.handleChange_new( e ,  "orden")}} />
          </td></tr>
          <tr><td>
          Rubro</td><td>
          <select className="select-css_global" value={this.state.new_id_rubro} onChange={(e) =>{this.handleChange_new( e ,  "id_rubro")}}>
          <option value="0" >Seleccione Rubro</option>
          {(this.state.rubros.length !== 0) ?
            this.state.rubros.map(rubro => (
              <option key={rubro.id_rubro} value={rubro.id_rubro} >{rubro.rubro}</option>
            ))
            : <React.Fragment></React.Fragment>
          }
          </select>
          </td></tr>
          <tr>
            <td colSpan="2">
              <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getnewItem()}>
                Crear Nuevo Producto
              </button>
            </td>
          </tr>
          </tbody>
        </table>

        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Información</th>
            <th>Imagen</th>
            <th>Opciones</th>
          </tr>
          </thead>
          {this.llenar_items()}
        </table>
        <br/><br/><br/><br/><br/>
      </div>
      {
        sub_pantalla_modal
      }
      </React.Fragment>
    )
  }

  componentDidMount (){
    this.cargar_items()
  }

}
export default getProductos;
